import { Button } from '@blueprintjs/core';
import styled from 'styled-components';

const StyledButton = styled(Button)`
	margin: 0 10px;
`;

export { StyledButton };
